export default {
  // 用户登陆
  login: "/login/user",
  // 注销登陆
  loginOut: "",

};



// WEBPACK FOOTER //
// ./src/http/api.js